// extracted by mini-css-extract-plugin
module.exports = {"shareButtons":"style-module--shareButtons---aMw6","shareButton":"style-module--shareButton--jgLoH"};